import { Button } from "../components/Button";
import { PageContainer, PageContent } from "../components/PageContainer";
import { TitleBar } from "../components/TitleBar";
import { tMsg } from "../components/ToastNotifications";
import apiAgent from "../api/apiAgent";
import { useAtom, useAtomValue } from "jotai";
import { userAtom } from "../atoms";
import { HomePublishSection } from "../components/Publishing";
import { addAnyNewPublishData } from "../components/Publishing/utils";
import { Link } from "react-router-dom";
import { publishGroups } from "../components/Publishing/publishConfig";
import { useEffect } from "react";

const SectionCard = ({ children }: { children: React.ReactNode }) => (
  <div className="w-full bg-black/10 p-8 flex flex-col gap-4">{children}</div>
);

// Custom types for the custom card below
interface IContentSectionProps {
  title: string;
  model: string;
  appGroup: keyof typeof publishGroups;
}

// Custom card for this CMS
const ContentSection = ({ title, model, appGroup }: IContentSectionProps) => (
  <SectionCard>
    <div className="flex gap-10">
      <div className="flex flex-col justify-between">
        <div className="font-bold">{title}</div>
        <div className="flex gap-2">
          <Link to={`/m/${model}`}>
            <Button className="text-sm">Manage</Button>
          </Link>
        </div>
      </div>
      <div className="flex gap-2">
        <HomePublishSection appGroup={appGroup} />
      </div>
    </div>
  </SectionCard>
);

// Custom home page configuration
const appContent: IContentSectionProps[] = [
  {
    title: "Memorial Profiles",
    model: "profile_node",
    appGroup: "profile_node",
  },
  {
    title: "Guardians",
    model: "content_node",
    appGroup: "content_node",
  },
  {
    title: "Feature Videos",
    model: "video_node",
    appGroup: "video_node",
  },
];

const Home = (): JSX.Element => {
  const [user, setUser] = useAtom(userAtom);

  useEffect(() => {
    if (!user) checkValidation(false);
  }, []);

  const checkValidation = async (showToast: boolean = true) => {
    const response = await apiAgent.Auth.validate();
    if (response.status === 200) {
      setUser(response.data);
      if (showToast) tMsg.success("Your login is valid");
    } else {
      if (showToast) tMsg.warning("Invalid login");
    }
  };

  // TODO: Add back if needed
  // const getScreensaver = async () => {
  //   const response = await apiAgent.SingleItem.get("screensaver");
  //   console.log(response);
  //   if (response.status === 200) {
  //     tMsg.success(response.data.body);
  //   } else {
  //     tMsg.warning("Error");
  //   }
  // };

  // TODO: Add back if needed
  // const resetScreensaver = async () => {
  //   const response = await apiAgent.SingleItem.update(
  //     "screensaver",
  //     { body: "" },
  //     JSON.stringify({ body: "wysiwyg" })
  //   );
  //   console.log(response);
  //   if (response.status === 200) {
  //     tMsg.info("screensaver reset");
  //   } else {
  //     tMsg.warning("Error");
  //   }
  // };

  return (
    <PageContainer>
      <PageContent className="flex flex-col gap-4">
        <SectionCard>
          <TitleBar
            title={user?.username ? `Welcome ${user?.username}!` : "Welcome!"}
          />
          <div className="text-sm space-y-4">
            <p>
              RFDS staff can use this Content Management System to add, edit and
              delete content on the Outback Guardians touchscreen.
            </p>
            <p>
              Content can be found in the Memorial Profiles, Guardians and
              Feature Videos sections in the left-hand navigation panel. Users
              can be organised in the Manage Users section (visible to Admin
              accounts only).
            </p>
          </div>
        </SectionCard>
        {appContent.map((item, index) => (
          <ContentSection {...item} key={index} />
        ))}
      </PageContent>
    </PageContainer>
  );
};

export default Home;
